<template>
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
            <vs-card>
                <vs-table
                    id="contact-table"
                    ref="table"
                    stripe
                    pagination
                    max-items="20"
                    search
                    :data="users"
                    class="text-nowrap"
                >
                    <div slot="header">
                        <vs-button icon="add" color="primary" @click="activePrompt = true">Add User</vs-button>
                        <!---Add Contact --->
                        <user-form
                            form-type="insert"
                            :active-prompt="activePrompt"
                            v-on:isClosed="activePrompt = false"
                            v-on:userCreated="createUser($event)"
                            :user="user"
                        >
                        </user-form>
                    </div>

                    <template slot="thead">
                        <vs-th sort-key="id">Id</vs-th>
                        <vs-th sort-key="name">User Info</vs-th>
                        <vs-th sort-key="status">Status</vs-th>
                        <vs-th sort-key="created_at">Created At</vs-th>
                        <vs-th sort-key="updated_at">Updated At</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :data="user" :key="key" v-for="(user, key) in data" @click.native="openUser(user.id)">
                            <vs-td :data="user.id">
                                <div>
                                    <span class="badge badge-light badge-pill border border-muted">{{user.id}}</span>
                                </div>
                            </vs-td>
                            <vs-td :data="user.name">
                                <div class="d-flex no-block align-items-center">
                                    <div class="mr-2">
                                        <img
                                            :src="user.avatar"
                                            alt="user"
                                            class="rounded-circle"
                                            width="45"
                                        />
                                    </div>
                                    <div class>
                                        <h5 class="mb-0 font-16">{{ user.name }}</h5>
                                        <span class="text-muted">{{ user.username }}</span>
                                    </div>
                                </div>
                            </vs-td>

                            <vs-td :data="user.status">
                                <div class="d-flex align-items-center">
                                    <span :class="'badge badge-pill badge-'+ statusClass[user.status]">{{user.status_text}}</span>
                                </div>
                            </vs-td>

                            <vs-td :data="user.created_at">
                                <div class="d-flex align-items-center">
                                    <i class="mdi mdi-calendar-text mr-2 display-8"></i>
                                    <span>{{user.created_at}}</span>
                                </div>
                            </vs-td>

                            <vs-td :data="user.updated_at">
                                <div class="d-flex align-items-center">
                                    <i class="mdi mdi-calendar-text mr-2 display-8"></i>
                                    <span>{{user.updated_at}}</span>
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </vs-card>
        </vs-col>
    </vs-row>
</template>

<script>
    import { UsersService } from './../../services/users.service';
    import UserForm from './Form';
    import NProgress from 'nprogress';

    export default {
        name : 'UsersList',
        components: {
            UserForm
        },
        data: () => ({
            activePrompt: false,
            user: {
                id: 0,
                name: '',
                username:''
            },
            users:[],
            statusClass: {
                0: 'danger',
                1: 'success'
            }
        }),

        async created() {
            NProgress.start();
            UsersService.all()
                .then(data => {
                    NProgress.done();
                    this.$log.debug('USERS', data);
                    this.users = data.data;
                })
                .catch( error => {
                    NProgress.end();
                    error.alert()
                });
        },

        methods:{
            createUser(user) {
                this.users.push(user);
            },

            openUser(id) {
                this.$router.push({name: 'user', params:{id: id}});
            }
        }
    }
</script>

<style>
#contact-table .vs-table--pagination {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
</style>
